angular.module('core').filter('teachers', [ 'numberFilter',
	function($numberFilter) {
		return function(input) {
			if(_.isUndefined(input) || !_.isNumber(input)) {
				return '';
			}
			else {
				if (input === 1) {
					return input + ' teacher';
				} else {
					return $numberFilter(input) + ' teachers';
				}
			}
		};
	}
]);
